import { render, staticRenderFns } from "./ed-student-list.component.vue?vue&type=template&id=4202d1cb&scoped=true&"
import script from "./ed-student-list.component.ts?vue&type=script&lang=ts&"
export * from "./ed-student-list.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-student-list.component.scss?vue&type=style&index=0&id=4202d1cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4202d1cb",
  null
  
)

export default component.exports